<template>
    <div>
        <common-access-filter :action="filterAction"></common-access-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
    import { ApiUrl } from '@/common/api.service'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import commonAccessFilter from './common-access-filter'
    import commonAccessActions from '../datatable/common-access-actions'
    import { i18n } from '@/plugins/i18n'
    import {
        statusStrForCommonAccess,
        statusVariantForCommonAccess
    } from '@/constants/settlementStatus'
    import actions from "../datatable/actions";

    export default {
        components: {
            commonAccessFilter
        },
        data() {
            return {
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                query: {}
            }
        },
        computed: {
            datatableProps() {
                return {
                    id: "settlement_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('settlement'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 15,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        saveState: {
                            cookie: false,
                        }
                    },
                    pagination: false,
                    sortable: true,
                    columns: [
                        {
                            field: 'id',
                            title: i18n.t('label.settlement_id'),
                            sortable: true,
                            width: 65,
                            selector: false,
                            textAlign: 'left', // in rtl version means right
                        },
                        {
                            field: 'amount',
                            title: i18n.t('label.amount') + " (" + i18n.t('currency.rial') + ")",
                            sortable: true,
                            width: 140,
                            textAlign: 'center',
                        },
                        {
                            field: 'bank_reference',
                            title: i18n.t('label.bank_reference'),
                            sortable: false,
                            width: 140,
                            textAlign: 'center',
                        },
                        {
                            field: 'created_at',
                            title: i18n.t('label.date_requested'),
                            sortable: true,
                            textAlign: 'center',
                            width: 150,
                        },
                        {
                            field: 'payment_date',
                            title: i18n.t('label.date_payed'),
                            sortable: true,
                            textAlign: 'center',
                            width: 150,
                        },
                        {
                            field: 'status',
                            title: i18n.t('label.status'),
                            width: 80,
                            textAlign: 'left',
                            template: (row) => {
                                let variant   = 'badge-'+statusVariantForCommonAccess(row.status)
                                let status = statusStrForCommonAccess.get(row.status)

                                return '<div class="badge '+variant+' text-white">'+ status +'</div>'
                            },
                            sortable: true,
                        },
                    ],
                    actions: commonAccessActions
                }
            }
        },
        methods: {
            filterAction(e, query) {
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            }
        }
    }
</script>

<style scoped>

</style>